<nav
  class="navbar navbar-dark navbar-expand-lg d-none d-lg-flex bg-primary position-relative p-0"
  [ngClass]="{ 'kid-nav': isKid }"
>
  <!--Logos on nav bar-->
  <a class="navbar-brand py-0 ms-2" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img
      alt=""
      class="ms-1 h-100"
      aria-labelledby="homeLink"
      [src]="isKid ? ('logo/logo-kid.svg' | contentAssetImage) : ('logo/logo.svg' | contentAssetImage)"
      draggable="false"
    />
  </a>

  <div class="nav-container position-absolute">
    <ul class="navbar-nav navbar-nav-container" #greedyNav>
      <li class="nav-item mx-2 active">
        <a class="nav-link" [routerLink]="['/rewards/raffles']" routerLinkActive="router-link-active">
          {{ 'navbar.rewards' | translate : { fgbdefault: 'Rewards' } }}
        </a>
      </li>
      <li class="nav-item mx-2 active">
        <a class="nav-link" [routerLink]="['/challenges']" routerLinkActive="router-link-active">
          {{ 'nav.challenges' | translate : { fgbdefault: 'Challenges' } }}
        </a>
      </li>
      <li class="nav-item mx-2 active">
        <a class="nav-link mx-1" [routerLink]="['/games']" routerLinkActive="router-link-active">{{ 'nav.games' | translate }}</a>
      </li>
      <li class="nav-item mx-2 active" *notInPopulation="[populations.Kids]">
        <a class="nav-link mx-1" [routerLink]="['/rewards/wallet']" routerLinkActive="router-link-active">{{
          'nav.wallet' | translate
        }}</a>
      </li>
      <li class="nav-item mx-2 active" *inPopulation="[populations.Kids]">
        <a class="nav-link mx-1" [routerLink]="['/worksheet']" routerLinkActive="router-link-active">{{
          'nav.worksheet' | translate
        }}</a>
      </li>
    </ul>
  </div>

  <!-- Right Side Content -->
  <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0 right-side-container ms-auto me-3">
    <!--Nav Credit-->
    <div class="balance me-3" *notInPopulation="[populations.Kids]">
      <span class="material-symbols-outlined text-white nav-credit-icon me-1">money_bag</span>
      <span class="fw-bold text-white font-size-14">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
    </div>
    <!--Notifications-->
    <fgb-notification-button></fgb-notification-button>
    <button
      class="nav-link btn text-white d-flex align-items-center px-0 justify-content-end ms-auto"
      (click)="isNavOpen = !isNavOpen"
      attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
      tabindex="-1"
      focusTab
    >
      <i class="material-symbols-outlined material-icons">menu</i>
    </button>
  </div>
</nav>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu shadow bg-white" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="right-nav-menu-header">
    <div id="brand-logo">
      <img alt="" aria-labelledby="homeLink" [src]="'logo/logo-dark.svg' | contentAssetImage" draggable="false" />
    </div>
    <button class="btn-nav-close text-info pe-0" (click)="isNavOpen = false">
      <i class="material-icons">close</i>
    </button>
  </div>

  <ng-container *ngIf="memberDetails$ | async as memberDetails">
    <div class="member-info" [ngClass]="{ 'kid-info': isKid }">
      <div class="d-flex justify-content-between align-items-center">
        <!--Name and ID-->
        <div class="card-id text-start text-white">
          <h5 class="mb-0 card-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</h5>
          <div class="d-flex product-code font-size-14">
            {{ ('member.card.id' | translate) + ' : ' + memberDetails.ExternalRefNumber }}
          </div>
        </div>
      </div>
    </div>
    <div class="right-nav-menu-list">
      <ul class="navbar-nav me-auto w-100" #greedyNav>
        <li class="nav-item active">
          <a
            [routerLink]="['/account']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.account.screenreader' | translate : { fgbdefault: 'Move to account page' } }}"
            class="d-flex align-items-center account-btn bg-white py-0 px-2 font-size-14 nav-item-fixed-height rounded-top right-nav-menu-item"
            ngbDropdownItem
          >
            <span class="icon material-icons material-symbols-outlined material-dropdown-icon me-2" aria-hidden="true"
              >account_circle</span
            >
            <div class="dropdown-link text-start">
              <div class="mt-0 nav-text">{{ 'account.nav.profile' | translate }}</div>
            </div>
          </a>
        </li>
        <li class="nav-item active">
          <a
            [routerLink]="['/gallery']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.account.screenreader' | translate : { fgbdefault: 'Move to account page' } }}"
            class="d-flex align-items-center account-btn bg-white py-0 px-2 font-size-14 nav-item-fixed-height rounded-top right-nav-menu-item"
            ngbDropdownItem
          >
            <span class="icon material-icons material-symbols-outlined material-dropdown-icon me-2"> animated_images </span>
            <div class="dropdown-link text-start">
              <div class="mt-0 nav-text">{{ 'nav.gallery' | translate }}</div>
            </div>
          </a>
        </li>
        <li class="nav-item active" *inPopulation="[populations.Kids]">
          <a
            [routerLink]="['/rewards/wallet']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.account.screenreader' | translate : { fgbdefault: 'Move to account page' } }}"
            class="d-flex align-items-center account-btn bg-white py-0 px-2 font-size-14 nav-item-fixed-height rounded-top right-nav-menu-item"
            ngbDropdownItem
          >
            <span class="icon material-icons material-symbols-outlined material-dropdown-icon me-2">
              account_balance_wallet
            </span>
            <div class="dropdown-link text-start">
              <div class="mt-0 nav-text">{{ 'nav.wallet' | translate }}</div>
            </div>
          </a>
        </li>
        <li>
          <button
            class="d-flex align-items-center bg-white py-0 px-2 font-size-14 nav-item-fixed-height p w-100 border-0 right-nav-menu-item justify-content-between"
            attr.aria-label="{{ 'nav.help.screenreader' | translate : { fgbdefault: 'Click for help pages' } }}"
            (click)="isCollapsed = !isCollapsed"
          >
            <div class="d-flex align-items-center">
              <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">info</span>
              <div class="dropdown-link text-start">
                <div class="nav-text mt-0">{{ 'nav.help' | translate }}</div>
              </div>
            </div>
            <span
              [@expandAnimation]="isCollapsed ? 'close' : 'open'"
              class="icon material-icons material-dropdown-icon m-0"
              aria-hidden="true"
              >keyboard_arrow_down</span
            >
          </button>
          <ul class="sub-nav" *ngIf="isCollapsed">
            <li class="nav-item active">
              <a
                class="nav-link mx-1 right-nav-menu-item"
                [routerLink]="['/terms']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
                >{{ 'nav.terms' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1 right-nav-menu-item"
                [routerLink]="['/faq']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to faq page' } }}"
                >{{ 'nav.faq' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1 right-nav-menu-item"
                [routerLink]="['/contact']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
                >{{ 'nav.contact.us' | translate }}</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <a class="logout-btn text-error cursor-pointer mt-auto" (click)="logout()">
      <i class="material-symbols-outlined material-icons me-2">logout</i>
      <span>{{ 'nav.log.out' | translate }}</span>
    </a>
  </ng-container>
</div>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
